const po = {
	login: 'Conecte-se',
	logout: 'Sair',
	signin: 'assinar em',
	signup: 'inscrever-se',
	email: 'o email',
	emailAddr: 'Endereço de e-mail',
	password: 'senha',
	rememberMe: 'Lembre de mim',
	forgotYourPwd: 'Esqueceu sua senha?',
	signinFacebook: 'Entrar com o Facebook',
	signinGoogle: 'Faça login no Google',
	dontAccount: 'Não possui uma conta?',
	firstName: 'Primeiro nome',
	lastName: 'Último nome',
	confirmPwd: 'Confirme a Senha',
	signup_msg: 'Ao clicar em aderir agora, você concorda com o',
	digitX_user_agreement: 'Contrato de usuário do DigitXchange',
	privacy_policy: 'Política de Privacidade',
	and: ' e ',
	cookies_policy: 'Política de Cookies',
	have_account: 'Já tem uma conta',
	forgotPwd: 'Esqueceu a senha',
	recoverPwd: 'RECUPERAR SENHA',
	forgotPwd_msg: 'Coloque seu email no campo acima, nós lhe enviaremos um link com as instruções a seguir.',
	changePwd: 'Mudar senha',
	oldPwd: 'Senha Antiga',
	newPwd: 'Nova senha',
	confirmNewPwd: 'Confirme a nova senha',
	user_account: 'Conta de usuário',
	change_pic: 'Alterar imagem',
	mobile_number: 'Número de celular',
	country: 'País',
	update_settings: 'Atualizar configurações',
	company: 'Companhia',
	aboutUs: 'Sobre nós',
	tos: 'PARA% S',
	copyright: 'direito autoral',
	socialMedia: 'Mídia social',
	forUpdates: 'para atualizações',
	footer_msg_1: 'Ao se inscrever, você aceita',
	terms: 'Termos de serviço',
	contactUs: 'Contate-Nos',
	yourEmail: 'Seu email',
	required: 'requeridos',
	yourMsg: 'Sua mensagem',
	sent: 'Enviei',
	footer_msg_2: 'Todos os direitos reservados',
	footer_msg_3: 'Todos os nomes de produtos, marcas comerciais e marcas registradas são de propriedade de seus respectivos proprietários',
	doom: 'Doom III',
	filter: 'Filtro',
	add_asset: 'Adicionar ativo',
	request_game: 'Pedir Jogo',
	search_msg: 'Desculpe, mas nada corresponde aos seus termos de pesquisa.',
	post: 'Postar',
	asset: 'De ativos',
	create: 'Crio',
	character: 'Personagem',
	characters: 'Personagens',
	assets: 'Ativos',
	profile: 'Perfil',
	game: 'jogos',
	games: 'Jogos',
	currency: 'Moeda',
	store: 'Loja',
	all_time: 'Tempo todo',
	this_month: 'Este mês',
	trending: 'Tendência',
	item_name: 'Nome do item',
	view_item: 'Ver item',
	leaderboard: 'Entre os melhores',
	posters: 'Pôsteres',
	chinese: 'chinês',
	english: 'Inglês',
	japanese: 'japonês',
	korean: 'coreano',
	german: 'alemão',
	french: 'francês',
	spanish: 'espanhol',
	italian: 'italiano',
	russian: 'russo',
	portuguese: 'Português',
	hindi: 'hindi',
	arabic: 'árabe',
	buy: 'Comprar',
	subscription: 'Inscrição',
	buy_subscription: 'Comprar assinatura',
	gift: 'Presente',
	xchange: 'Xchange',
	subscription_plan: 'Plano de Assinatura',
	payment_options: 'Opções de pagamento',
	cardholder_name: 'Nome do Titular',
	submit_order: 'Enviar pedido',
	card_number: 'Número do cartão',
	cvv: 'CVV',
	expiration_date: 'Data de validade',
	buyXchange: 'Comprar Xchange',
	giftXchange: 'Gift Xchange',
	or: 'ou',
	select: 'Selecione',

	search: 'Procurar',
	search_games: 'Pesquisar jogos ...',
	search_assets: 'Pesquisar ativos ...',
	platform: 'Plataforma',
	total_posts: 'Total de Mensagens',
	total_comments: 'Total de Comentários',
	total_characters: 'Total de caracteres',
	total_assets: 'Total de ativos',
	xchange_currency: 'Xchange Currency',
	subscription_days_remaining: 'Dias de assinatura restantes',
	total_asset_networth: 'Patrimônio líquido total do ativo',
	total_character_networth: 'Networth total de caracteres',
	most_downloaded: 'Mais baixados',
	recently_added: 'Adicionado recentemente',
	genre: 'Gênero',
	my_library: 'Minha biblioteca',
	most_commented: 'mais comentado',
	most_recent: 'Mais recente',
	nearing_addition: 'Aproximação de adição',
	create_asset: 'Criar ativo',
	create_character: 'Criar personagem',
	asset_name: 'Nome do ativo',
	asset_type: 'Tipo de ativo',
	rarity: 'Raridade',
	enhancements: 'Aprimoramentos',
	add: 'Adicionar',
	currency_type: 'Tipo de Moeda',
	price: 'Preço',
	description: 'Descrição',
	upload_asset: 'Carregar ativo',
	preview_asset: 'Visualizar ativo',
	main_image: 'Imagem principal',
	upload_video: 'Envio vídeo',
	upload: 'Envio',
	view_demo: 'Ver demonstração',
	character_name: 'Nome do personagem',
	character_type: 'Tipo de Personagem',
	upload_character: 'Carregar personagem',
	preview_character: 'Personagem de visualização',
	race: 'Corrida',
	class: 'Classe',
	gender: 'Gênero',
	level: 'Nível',
	showing: 'Mostrando',
	of: 'do',
	results: 'resultados',
	featured_characters: 'Personagens em destaque',
	url: 'URL',
	submit: 'Enviar',
	real_world: 'Mundo real',
	game_currency: 'Moeda do jogo',
	all: 'Todos',

	edit: 'Editar',
	save: 'Salve',
	agg_character_networth: 'Networth de caráter agregado',
	agg_time_played: 'Tempo agregado jogado',
	agg_asset_value: 'Valor agregado do ativo',
	enter_character_creation_date: 'Digite a data de criação do caractere',
	in_game_currency: 'Moeda no jogo',
	real_world_value: 'Valor do mundo real',
	update_character: 'Atualizar Personagem',
	item_not_found: 'Item não encontrado!',
	ripper: 'Estripador',
	comments: 'Comentários',
	add_comments: 'Adicione comentários',
	new_suggested_price: 'Novo Preço Sugerido',
	sort_by: 'Ordenar por',
	reply: 'Resposta',
	asset_networth: 'Patrimônio líquido',
	join_date: 'Data de inscrição',
	report: 'Relatório',
	first: 'Primeiro',
	last: 'Último',
	most_replies: 'Mais Respostas',
	new_pricing_recommendations: 'Novas recomendações de preços',
	xchange_amount: 'Xchange Montante',
	username: 'Nome do usuário',
	send_gift: 'Enviar presente',
	message: 'mensagem',
	gift_text: 'Personalize sua mensagem aqui',
	day: 'dia',
	days: 'dias',
	currency_converter: 'Conversor de moeda',
	from: 'De',
	to: 'Para',
	in_game: 'No jogo',
	real_life: 'Vida real',
	cvc: 'CVC',
	card: 'Cartão',
	per_month: 'Mensal (US $ 3 por mês)',
	per_year: 'Anual (US $ 30 por ano)',
	aboutUs_text: 'O DigitXChange é um site voltado para a comunidade que visa finalmente valorizar os bens e serviços digitais por meio de crowdsourcing. Se você já fez a pergunta "quanto meu personagem realmente vale" ou "eu me pergunto o que seria um comércio justo com outro jogador em outro jogo", não procure mais as respostas. Esperamos que você goste do nosso site, participe da construção do conhecimento do grupo, mostre seu saque suado e, finalmente, espere descobrir seu patrimônio líquido digital total!',
	home: 'Pagina inicial',
	all_time_characters: 'Personagens de todos os tempos',
	this_month_characters: 'Personagens deste mês',
	trending_characters: 'Personagens em Destaque',
	all_time_posters: 'Sempre Pôsteres',
	this_month_posters: 'Este Mês Pôsteres',
	trending_posters: 'Tendências Pôsteres',
	
};

export default po;


// WEBPACK FOOTER //
// ./src/translations/po.js